<app-frame-1
  [appPageTitle]="appPageTitle"
  [appFavicon]="appFavicon"
  [links]="links"
  [content]="content"
  [contacts]="contacts"
  [logo]="logo"
  [logoLink]="logoLink"
  [logoName]="logoName"
  [logoSlogan]="logoSlogan"
  [logoSloganMobile]="logoSloganMobile"
  [copyRightInfo]="copyRightInfo"
  [ngStyle]="{ '--primary-color': 'rgb(0, 161, 253)' }"
  [type]="type"
  [style.--nav-background-color]="'transparent'"
  [style.--text-color]="'#000'"
  [style.--icon-color]="'#000'"
  [style.--special-button-text-color]="'rgb(0, 161, 253)'"
  [style.--special-button-background-color]="'transparent'"
  [style.--special-button-border-color]="'none'"
  [style.--footer-background-color]="'#0F1112'"
  [style.--copy-right-color]="'#72787E'"
>
  <app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>

  <ng-content></ng-content>

  <sm-container
    class="app-new-footer"
    [style]="{
      '--max-content-width': '1500px',
      backgroundColor: '#1C1F21'
    }"
  >
    <app-footer
      [content]="content"
      [contacts]="contacts"
      [type]="type"
    ></app-footer>
  </sm-container>
</app-frame-1>
